module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "detailData",
    attrs: {
      "element-loading-text": _vm.$t('common.loading')
    }
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('tradeMng.crumbs.L1')))]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/main/transctl'
      },
      "replace": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.crumbs.L4')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.type === 'refund' ? _vm.$t('tradeMng.crumbs.L3') : _vm.$t('tradeMng.crumbs.L2')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.type === 'refund' ? _vm.$t('tradeMng.crumbs.L3') : _vm.$t('tradeMng.crumbs.L2')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper",
    class: {
      'wrapper': _vm.lang === 'ja' || _vm.lang === 'en'
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.type === 'refund' ? _vm.$t('tradeMng.detail.amount2') : _vm.$t('tradeMng.detail.amount1')))]), _vm._v(" "), (_vm.type === 'digital') ? _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.role.currency) + " " + _vm._s(_vm._f("formatCurrency")(_vm.infoData.order_amt)))]) : _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.role.currency) + " " + _vm._s(_vm._f("formatCurrency")(_vm.infoData.txamt)))])]), _vm._v(" "), (_vm.type === 'digital') ? _c('div', [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.detail.amount3')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.role.currency) + " " + _vm._s(_vm._f("formatCurrency")(_vm.infoData.txamt)))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.detail.count2')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.order_quantity))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.detail.count1')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.actual_quantity))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.tradeState')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.status === 1 ? _vm.$t('tradeMng.dialog.d3') : _vm.$t('tradeMng.dialog.d4')))])]), _vm._v(" "), (_vm.type === 'trans') ? _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.tradeType')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.busicd_info))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.type === 'refund' ? _vm.$t('tradeMng.detail.time') : _vm.$t('tradeMng.table.tradeTime')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.sysdtm))])]), _vm._v(" "), (_vm.type === 'digital') ? _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.detail.syssn4')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.chain_order_no))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.type === 'refund' ? _vm.$t('tradeMng.detail.syssn3') : _vm.$t('tradeMng.detail.syssn1')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.syssn))])]), _vm._v(" "), (_vm.type === 'refund') ? _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.detail.syssn2')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.origssn))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.detail.store')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.shopname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.detail.account')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.opuser))])]), _vm._v(" "), (_vm.infoData.refund_src) ? _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.detail.refundApplicationSource')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.refund_src))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.remark')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.infoData.note || _vm.$t('common.none')))])])])])]), _vm._v(" "), (_vm.type === 'trans') ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.detail.history')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listData,
      "row-class-name": "el-table__row_fix"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sysdtm",
      "label": _vm.$t('tradeMng.detail.time')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "txamt",
      "label": _vm.$t('tradeMng.detail.amount2') + '(' + _vm.role.currency + ')'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.txamt)))]
      }
    }], null, false, 2945048276)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "opuser",
      "label": _vm.$t('tradeMng.detail.account')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('tradeMng.table.op')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.showDetail(scope.row.syssn)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.detail')))])]
      }
    }], null, false, 2044847857)
  })], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4a715b1c"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/transdetail/transdetail.vue
// module id = 917
// module chunks = 0